import { render, staticRenderFns } from "./shuhadaById.vue?vue&type=template&id=57eb80d8&scoped=true"
import script from "./shuhadaById.vue?vue&type=script&lang=js"
export * from "./shuhadaById.vue?vue&type=script&lang=js"
import style0 from "./shuhadaById.vue?vue&type=style&index=0&id=57eb80d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb80d8",
  null
  
)

export default component.exports